import { Income } from '@app/api';
import { i18n } from '@app/i18n';

const mapPrefix = 'participants.enums.incomes';

export const isIncomeCountrySpecific = (countries: string[]) => {
  return (
    countries.length === 1 &&
    countries[0] !== 'WORLDWIDE' &&
    i18n.exists(`${mapPrefix}.${countries[0]}.D0_D3`)
  );
};

export const getIncomes = (countries: string[]) => {
  const isCountrySpecific = isIncomeCountrySpecific(countries);
  const prefix = `${mapPrefix}.${
    isCountrySpecific ? countries[0] : 'WORLDWIDE'
  }`;

  // prettier-ignore
  return [
    { value: Income.D0_D3, label: `${prefix}.D0_D3`                                 },
    { value: Income.D3_D7, label: `${prefix}.D3_D7`,      hidden: isCountrySpecific },
    { value: Income.D3_D5, label: `${prefix}.D3_D5`,      hidden: !isCountrySpecific},
    { value: Income.D5_D7, label: `${prefix}.D5_D7`,      hidden: !isCountrySpecific},
    { value: Income.D7_D8, label: `${prefix}.D7_D8`,                                },
    { value: Income.D8_D9, label: `${prefix}.D8_D9`,      hidden: !isCountrySpecific},
    { value: Income.D8_C95, label: `${prefix}.D8_C95`,    hidden: isCountrySpecific },
    { value: Income.C90_C95, label: `${prefix}.C90_C95`,  hidden: !isCountrySpecific},
    { value: Income.C95_C98, label: `${prefix}.C95_C98`,  hidden: !isCountrySpecific},
    { value: Income.C95P, label: `${prefix}.C95P`,        hidden: isCountrySpecific },
    { value: Income.C98P, label: `${prefix}.C98P`,        hidden: !isCountrySpecific},
  ];
};

export const getIncomeText = (
  income: Income,
  country: string[] | string | undefined,
) => {
  if (!country) {
    return `${mapPrefix}.WORLDWIDE.${income}`;
  }
  const countries = Array.isArray(country) ? country : [country];
  const isCountrySpecific = isIncomeCountrySpecific(countries);
  const prefix = `${mapPrefix}.${
    isCountrySpecific ? countries[0] : 'WORLDWIDE'
  }`;

  return `${prefix}.${income}`;
};
